import { Component, OnInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule, FormArray } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';

import { RecepcionesService } from '../../Service/recepciones-service';
import { ToastService } from '../../Service/toast-service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'; // 🚀 INYECTADO: Seguridad visual de Angular

@Component({
  selector: 'app-recepciones-edit',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule,
    MatSelectModule, MatFormFieldModule, MatDividerModule
  ],
  templateUrl: './recepciones-edit.html',
  styleUrl: './recepciones-edit.css',
})
export class RecepcionesEdit implements OnInit {
  editForm!: FormGroup;
  pinesCarroceria: any[] = [];
  currentVehicleSvg: string = 'images/croquis-sedan.svg';
  recepcionId!: number;
  data: any; // Almacena el respaldo crudo del backend para las etiquetas

  mostrarMenuFlotante = false;
  posicionPantallaMenu = { left: 0, top: 0 };
  coordenadasPorcentajeProvisional = { x: 0, y: 0 };
  comentarioTemporal = '';

  private mapperCarroceria: { [key: string]: string } = {
    'Sedán': 'sedan', 
    'Pickup': 'pickup', 
    'SUV': 'suv', 
    'Camión': 'camion', 
    'Autobús': 'autobus'
  };

  // =========================================================================
  // CATÁLOGOS ESTÁTICOS AGRUPADOS (PRODUCTOS / PERTENENCIAS)
  // =========================================================================
  productosAgrupados = [
  {
    categoria: 'Inventario de Pertenencias y Accesorios',
    opciones: [

      { id: 'LLANTA DE REFACCIÓN', nombre: 'Llanta de refacción' },
      { id: 'GATO HIDRÁULICO', nombre: 'Gato hidráulico' },
      { id: 'MANERAL', nombre: 'Maneral' },
      { id: 'LLAVE DE CRUZ', nombre: 'Llave de cruz' },
      { id: 'LLAVE PARA AUTOMÓVIL', nombre: 'Llave para automóvil' },
      { id: 'CONTROL REMOTO (ALARMA/PORTÓN/COCHERA)', nombre: 'Control remoto (Alarma - Portón - Cochera)' },
      { id: 'CABLES PASA CORRIENTE', nombre: 'Cables pasa corriente' },
      { id: 'KIT DE HERRAMIENTAS BÁSICAS', nombre: 'Kit de herramientas básicas' },
      { id: 'ESTUCHE DE DADOS - AUTOCLE', nombre: 'Estuche de dados - autocle' },
      { id: 'TRIÁNGULOS DE SEGURIDAD (REFLEJANTES)', nombre: 'Triángulos de seguridad (reflejantes)' },
      { id: 'EXTINTOR', nombre: 'Extintor' },
      { id: 'BOTIQUÍN DE PRIMEROS AUXILIOS', nombre: 'Botiquín de primeros auxilios' },
      { id: 'AUTOESTÉREO - PANTALLA CENTRAL', nombre: 'Autoestéreo - Pantalla central' },
      { id: 'ESTÉREO O PANTALLA DESMONTABLE', nombre: 'Estéreo o pantalla desmontable' },
      { id: 'BOCINAS - AMPLIFICADOR - SUBWOOFER', nombre: 'Bocinas - Amplificador - Subwoofer' },
      { id: 'TAPETES - ALFOMBRAS', nombre: 'Tapetes - Alfombras' },
      { id: 'ENCENDEDOR DE CIGARROS - ADAPTADOR USB', nombre: 'Encendedor de cigarros - Adaptador USB' },
      { id: 'SOPORTE PARA TELÉFONO CELULAR - IMÁN', nombre: 'Soporte para teléfono celular - imán' },
      { id: 'MANUAL DEL USUARIO - CARNET DE SERVICIOS', nombre: 'Manual del usuario - Carnet de servicios' },
      { id: 'TARJETA DE CIRCULACIÓN - DOCUMENTOS', nombre: 'Tarjeta de circulación - Documentos' },
      { id: 'TAG DE PEAJE (PASE/TELEVÍA)', nombre: 'Tag de peaje (Pase/Televía)' },
      { id: 'SOMBRILLA - PARAGUAS', nombre: 'Sombrilla - Paraguas' },
      { id: 'DOCUMENTOS EN LA GUANTERA', nombre: 'Documentos en la guantera' },
      { id: 'ANTENA', nombre: 'Antena' },
      { id: 'TAPONES DE RUEDAS', nombre: 'Tapones de ruedas' },
      { id: 'OBJETOS PERSONALES OLVIDADOS', nombre: 'Objetos personales olvidados' }
    ]
  },
  {
    categoria: 'Estado Físico de la Carrocería (Inspección Visual)',
    opciones: [
      { id: 'DEFENSA DELANTERA - FASCIA', nombre: 'Defensa delantera - Fascia' },
      { id: 'DEFENSA TRASERA - FASCIA', nombre: 'Defensa trasera - Fascia' },
      { id: 'COFRE', nombre: 'Cofre' },
      { id: 'TOLDO - TECHO', nombre: 'Toldo - Techo' },
      { id: 'QUEMACOCOS - TECHO PANORÁMICO', nombre: 'Quemacocos - Techo panorámico' },
      { id: 'CAJUELA - QUINTA PUERTA', nombre: 'Cajuela - Quinta puerta' },
      { id: 'SALPICADERA DELANTERA IZQUIERDA', nombre: 'Salpicadera delantera izquierda' },
      { id: 'SALPICADERA DELANTERA DERECHA', nombre: 'Salpicadera delantera derecha' },
      { id: 'PUERTA DELANTERA IZQUIERDA (PILOTO)', nombre: 'Puerta delantera izquierda (Piloto)' },
      { id: 'PUERTA TRASERA IZQUIERDA', nombre: 'Puerta trasera izquierda' },
      { id: 'PUERTA DELANTERA DERECHA (COPILOTO)', nombre: 'Puerta delantera derecha (Copiloto)' },
      { id: 'PUERTA TRASERA DERECHA', nombre: 'Puerta trasera derecha' },
      { id: 'COSTADO - LATERAL TRASERO IZQUIERDO', nombre: 'Costado - Lateral trasero izquierdo' },
      { id: 'COSTADO - LATERAL TRASERO DERECHO', nombre: 'Costado - Lateral trasero derecho' },
      { id: 'ESPEJO RETROVISOR EXTERIOR IZQUIERDO', nombre: 'Espejo retrovisor exterior izquierdo' },
      { id: 'ESPEJO RETROVISOR EXTERIOR DERECHO', nombre: 'Espejo retrovisor exterior derecho' },
      { id: 'PARABRISAS (CRISTAL DELANTERO)', nombre: 'Parabrisas (Cristal delantero)' },
      { id: 'MEDALLÓN (CRISTAL TRASERO)', nombre: 'Medallón (Cristal trasero)' },
      { id: 'CRISTALES DE PUERTAS - LATERALES', nombre: 'Cristales de puertas - Laterales' },
      { id: 'FAROS PRINCIPALES DELANTEROS', nombre: 'Faros principales delanteros' },
      { id: 'CALAVERAS - LUCES TRASERAS', nombre: 'Calaveras - Luces traseras' },
      { id: 'LUCES AUXILIARES - FAROS DE NIEBLA', nombre: 'Luces auxiliares - Faros de niebla' },
      { id: 'PARRILLA FRONTAL Y EMBLEMAS', nombre: 'Parrilla frontal y emblemas' },
      { id: 'MOLDURAS LATERALES - ESTRIBOS', nombre: 'Molduras laterales - Estribos' },
      { id: 'TOLVAS INFERIORES - SALPICADERAS INTERNAS', nombre: 'Tolvas inferiores - Salpicaderas internas' },
      { id: 'TAPÓN DE DEPÓSITO DE GASOLINA', nombre: 'Tapón de depósito de gasolina' },
      { id: 'PLUMAS LIMPIAPARABRISAS (ESTADO FÍSICO HULE)', nombre: 'Plumas limpiaparabrisas (Estado físico hule)' },
      { id: 'RINES - TAPONES DE RUEDAS', nombre: 'Rines - Tapones de ruedas' },
      { id: 'LLANTAS (ESTADO VISUAL EXTERIOR)', nombre: 'Llantas (Estado visual exterior)' },
      { id: 'ANTENA DE RADIO', nombre: 'Antena de radio' }

    ]
  },
  {
    categoria: 'Condiciones Mecánicas y Testigos',
    opciones: [
      { id: 'TESTIGO: CHECK ENGINE - MIL', nombre: 'Testigo: Check Engine - MIL' },
      { id: 'TESTIGO: PRESIÓN DE ACEITE', nombre: 'Testigo: Presión de Aceite' },
      { id: 'TESTIGO: TEMPERATURA MOTOR', nombre: 'Testigo: Temperatura Motor' },
      { id: 'TESTIGO: SISTEMA ABS - FRENOS', nombre: 'Testigo: Sistema ABS - Frenos' },
      { id: 'TESTIGO: BOLSAS DE AIRE (AIRBAG)', nombre: 'Testigo: Bolsas de Aire (Airbag)' },
      { id: 'TESTIGO: BATERÍA - ALTERNADOR', nombre: 'Testigo: Batería - Alternador' },
      { id: 'TESTIGO: TPMS (PRESIÓN DE LLANTAS)', nombre: 'Testigo: TPMS (Presión de llantas)' },
      { id: 'TESTIGO: DIRECCIÓN ASISTIDA (EPS)', nombre: 'Testigo: Dirección Asistida (EPS)' },
      { id: 'TESTIGO: CONTROL DE ESTABILIDAD - TRACCIÓN (ESP - TCS)', nombre: 'Testigo: Control de Estabilidad - Tracción (ESP - TCS)' },
      { id: 'TESTIGO: FRENO DE MANO - LÍQUIDO BAJO', nombre: 'Testigo: Freno de mano - Líquido bajo' },
      { id: 'NIVEL DE ACEITE DE MOTOR', nombre: 'Nivel de Aceite de Motor' },
      { id: 'NIVEL DE LÍQUIDO DE FRENOS', nombre: 'Nivel de Líquido de Frenos' },
      { id: 'NIVEL DE LÍQUIDO REFRIGERANTE (ANTICONGELANTE)', nombre: 'Nivel de Líquido Refrigerante (Anticongelante)' },
      { id: 'LÍQUIDO DE DIRECCIÓN HIDRÁULICA', nombre: 'Líquido de Dirección Hidráulica' },
      { id: 'NIVEL DE LÍQUIDO LIMPIAPARABRISAS', nombre: 'Nivel de Líquido Limpiaparabrisas' },
      { id: 'ESTADO DE LA BATERÍA (FÍSICO - BORNES)', nombre: 'Estado de la Batería (Físico - Bornes)' },
      { id: 'BANDAS DE ACCESORIOS (MOTOR)', nombre: 'Bandas de accesorios (Motor)' },
      { id: 'FUGAS VISIBLES DE FLUIDOS (MOTOR - PISO)', nombre: 'Fugas visibles de fluidos (Motor - Piso)' },
      { id: 'PEDAL DE FRENO (SENSACIÓN)', nombre: 'Pedal de freno (Sensación)' },
      { id: 'PEDAL DE EMBRAGUE - CLOCHE', nombre: 'Pedal de embrague - Cloche' },
      { id: 'PALANCA DE VELOCIDADES - RESPUESTA TRANSMISIÓN', nombre: 'Palanca de velocidades - Respuesta transmisión' },
      { id: 'DIRECCIÓN (VIBRACIÓN O JALONEO)', nombre: 'Dirección (Vibración o jaloneo)' },
      { id: 'AIRE ACONDICIONADO - CALEFACCIÓN', nombre: 'Aire Acondicionado - Calefacción' },
      { id: 'LIMPIAPARABRISAS (MECANISMO ELECTRÓNICO)', nombre: 'Limpiaparabrisas (Mecanismo electrónico)' },
      { id: 'ELEVADORES DE CRISTALES - SEGUROS ELÉCTRICOS', nombre: 'Elevadores de cristales - Seguros eléctricos' },
      { id: 'LUCES E ILUMINACIÓN GENERAL (ALTAS - BAJAS - STOP)', nombre: 'Luces e iluminación general (Altas - Bajas - Stop)' },
      { id: 'EMISIÓN DE HUMO POR ESCAPE (VISUAL)', nombre: 'Emisión de humo por escape (Visual)' },
      { id: 'RUIDOS EXTRAÑOS EN MARCHA - MOTOR', nombre: 'Ruidos extraños en marcha - Motor' }
    ]
  }
];

  // =========================================================================
  // 🚀 VARIABLES DE AUDITORÍA FOTOGRÁFICA (SANA EL WORKFLOW DE ADJUNTOS)
  // =========================================================================
  archivosSeleccionados: File[] = []; // Almacena fotos nuevas tomadas en la edición
  fotosEliminadas: any[] = [];        // Rastrea las fotos viejas de MySQL a borrar en disco/S3

  // (Busca tu método ngOnInit y en la sección donde recibes la respuesta de Java 'next: (res: any) => {')
  // Asegúrate de que las fotos existentes se queden vivas en el objeto local:
  // this.data = res;  

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    this.archivosSeleccionados = [];
    if (files) {
      for (let i = 0; i < files.length; i++) {
        this.archivosSeleccionados.push(files[i]);
      }
    }
  }
  
  marcarFotoParaEliminar(foto: any): void {
    // La removemos visualmente de la pantalla al instante
    this.data.fotos = this.data.fotos.filter((f: any) => f !== foto);
    // La guardamos en la lista negra para avisarle a tu RecepcionesController.java
    this.fotosEliminadas.push(foto);
    this.cdr.detectChanges();
  }

  // =========================================================================
  // 🚀 VARIABLES DEL VISOR DE IMÁGENES FLOTANTE CON CARRUSEL NATIVO
  // =========================================================================
  mostrarVisorFotos = false;
  indiceFotoActual = 0;

  // Escuchador nativo del teclado: Si presionan ESC se cierra el carrusel de inmediato
  @HostListener('window:keydown.escape', ['$event'])
  manejarTeclaEscape(event: any): void {
    if (this.mostrarVisorFotos) {
      console.log('⌨️ [SaaS Carrusel] Tecla ESC detectada. Desvaneciendo visor flotante.');
      this.cerrarVisor();
    }
  }

  abrirVisorEnFoto(foto: any): void {
    // Localizamos la posición de la foto seleccionada en la lista de evidencias
    const index = this.data?.fotos?.indexOf(foto);
    if (index !== -1) {
      this.indiceFotoActual = index;
      this.mostrarVisorFotos = true;
    }
  }

  cerrarVisor(): void {
    this.mostrarVisorFotos = false;
  }

  fotoSiguiente(event: MouseEvent): void {
    event.stopPropagation(); // Evita que se cierre el modal por propagación de clic
    if (this.data?.fotos && this.indiceFotoActual < this.data.fotos.length - 1) {
      this.indiceFotoActual++;
    } else {
      this.indiceFotoActual = 0; // Carrusel infinito: regresa al inicio
    }
  }

  fotoAnterior(event: MouseEvent): void {
    event.stopPropagation();
    if (this.data?.fotos && this.indiceFotoActual > 0) {
      this.indiceFotoActual--;
    } else {
      this.indiceFotoActual = this.data.fotos.length - 1; // Carrusel infinito: va al final
    }
  }  

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private recepcionesService: RecepcionesService,
    public toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    console.log("📶 [JDE TELEMETRÍA EDIT] Inicializando componente de página completa...");

    // =========================================================================
    // 🚀 REFACTORIZACIÓN CORES DE SUB-OBJETOS REACTIVOS (CONSERVADO INTEGRAL)
    // =========================================================================
    this.editForm = this.fb.group({
      id: [null],
      folio: [''],
      fecha_entrada: [''],
      customer: this.fb.group({
        an8: [null, Validators.required] 
      }),
      unidad: this.fb.group({
        id: [null, Validators.required]   
      }),
      kilometraje: [null, [Validators.required, Validators.min(0)]],
      nivelCombustible: ['', Validators.required],
      observaciones_generales: [''],

      // 🌟 CONTROLES AGREGADOS PARA LA EDICIÓN
      modalidadCosto: ['GRATIS', Validators.required],
      costoMonto: [null],

      // 🟢 CORREGIDO: Inicializa en 'Sedán' en mayúscula y con acento exacto de tu UDC
      tipoSilueta: ['Sedán'], 
      detalles: this.fb.array([]),
      sintomas: this.fb.array([])
    });

    // Escucha activa de los parámetros de la URL parameter
    this.route.paramMap.subscribe({
      next: (params) => {
        const idUrl = params.get('id');
        console.log('👉 [JDE TELEMETRÍA EDIT] ID crudo detectado en la barra de URL:', idUrl);

        if (!idUrl || idUrl === '0') {
          console.error('❌ [JDE TELEMETRÍA EDIT] ¡ALERTA CRÍTICA! El ID llegó nulo. Revise app.routes.ts.');
          return;
        }

        this.recepcionId = parseInt(idUrl, 10);
        console.log('📶 [JDE TELEMETRÍA EDIT] Despachando consulta HTTP GET para ID:', this.recepcionId);

        this.recepcionesService.getRecepciones(this.recepcionId).subscribe({
          next: (res: any) => {
            console.log('📥 [JDE TELEMETRÍA EDIT] Respuesta cruda recibida de Java:', res);
            if (!res) return;
            
            // =========================================================================
            // 🛡️ ADUANA SANITIZADORA MULTI-PORT (SANA LAS IMÁGENES INVISIBLES)
            // SOLUCIÓN: Recorremos el arreglo de fotos e inyectamos una propiedad nueva
            // certificada como segura mediante bypassSecurityTrustUrl al conducto /uploads/.
            // =========================================================================
            if (res.fotos && res.fotos.length > 0) {
              res.fotos.forEach((foto: any) => {
                const rutaCompleta = `/uploads/${foto.urlFoto}`;
                foto.urlSanitizada = this.sanitizer.bypassSecurityTrustUrl(rutaCompleta);
              });
            }

            this.data = res; // Salvaguarda con URLs seguras para renderizar las etiquetas del HTML

            // Traducir el entero de base de datos a string para marcar el botón correcto en la UI
            let stringModalidad = 'GRATIS';
            if (res.modalidadCosto === 1) stringModalidad = 'FIJO';
            if (res.modalidadCosto === 2) stringModalidad = 'VARIABLE';
            if (res.modalidadCosto === 3) stringModalidad = 'ESPECIFICO';            

            // Hidratamos de forma segura los cabeceros basales y los subgrupos anidados
            this.editForm.patchValue({
              id: res.id,
              folio: res.folio,
              fecha_entrada: res.fecha_entrada,
              kilometraje: res.kilometraje,
              nivelCombustible: res.nivelCombustible,
              observaciones_generales: res.observaciones_generales,

              // 🌟 SETEAR LOS VALORES CARGADOS EN LA INTERFAZ
              modalidadCosto: stringModalidad,
              costoMonto: res.modalidadCosto === 3 ? res.costoMonto : null,           
              
              // 🟢 HIDRATACIÓN DE SUB-OBJETOS: Sella los controles internos grises
              customer: {
                an8: res.an8 || res.customer?.an8
              },
              unidad: {
                id: res.idVehiculo || res.unidad?.id
              },

              // 🟢 Sella la silueta histórica guardada o cae al fallback capitalizado "Sedán"
              tipoSilueta: res.tipoSilueta || 'Sedán'

            });

            // ASIGNACIÓN DEL LIENZO VECTORIAL: Prioriza la silueta de la orden
            const siluetaBase = res.tipoSilueta || (res.unidad?.tipoCarroceria ? res.unidad.tipoCarroceria : 'Sedán');
            const nombreArchivoSvg = this.mapperCarroceria[siluetaBase] || 'sedan';
            this.currentVehicleSvg = `images/croquis-${nombreArchivoSvg}.svg`;

            // Hidratamos las filas dinámicas de síntomas
            const sintomasArray = this.editForm.get('sintomas') as FormArray;
            while (sintomasArray.length !== 0) sintomasArray.removeAt(0);
            if (res.sintomas && res.sintomas.length > 0) {
              res.sintomas.forEach((s: any) => {
                // Sifón defensivo: Lee 'descripcion_falla' o 'descripcionFalla' de Java
                const textoFalla = s.descripcion_falla || s.descripcionFalla || '';
                
                sintomasArray.push(this.fb.group({
                  id: [s.id], 
                  descripcion_falla: [textoFalla.toUpperCase(), Validators.required]
                }));
              });
            }

            // Hidratamos las filas dinámicas del inventario
            const detallesArray = this.editForm.get('detalles') as FormArray;
            while (detallesArray.length !== 0) detallesArray.removeAt(0);
            if (res.detalles && res.detalles.length > 0) {
              res.detalles.forEach((d: any) => {
                // Sifones defensivos contra asimetrías de serialización de Spring Boot
                const nombreItem = d.item_nombre || d.itemNombre || '';
                const notaComentario = d.comentario_especifico || d.comentarioEspecifico || d.comentario_specifico || '';

                detallesArray.push(this.fb.group({
                  id: [d.id], 
                  item_nombre: [nombreItem, Validators.required],
                  estado: [d.estado, Validators.required], 
                  cantidad: [d.cantidad || 1], 
                  comentario_especifico: [notaComentario.toUpperCase()]
                }));
              });
            }

            // Renderizado de pines del croquis en el lienzo
            this.pinesCarroceria = res.detallesCarroceria ? [...res.detallesCarroceria] : [];

            if (res.unidad && res.unidad.tipoCarroceria) {
              const nombreArchivo = this.mapperCarroceria[res.unidad.tipoCarroceria] || 'sedan';
              this.currentVehicleSvg = `images/croquis-${nombreArchivo}.svg`;
            }

            this.cdr.detectChanges();
          },
          error: (err) => console.error('❌ Error al conectar con Java:', err)
        });
      }
    });
  }

  get detalles(): FormArray { return this.editForm.get('detalles') as FormArray; }
  get sintomas(): FormArray { return this.editForm.get('sintomas') as FormArray; }

  agregarLinea(): void {
    this.detalles.push(this.fb.group({ id: [null], item_nombre: ['', Validators.required], estado: ['', Validators.required], cantidad: [1, [Validators.required, Validators.min(1)]], comentario_especifico: [''] }));
    this.cdr.detectChanges();
  }
  removerLinea(index: number): void { if (this.detalles.length > 1) { this.detalles.removeAt(index); this.cdr.detectChanges(); } }
  agregarSintoma(): void { this.sintomas.push(this.fb.group({ id: [null], descripcion_falla: ['', Validators.required] })); this.cdr.detectChanges(); }
  removerSintoma(index: number): void { if (this.sintomas.length > 1) { this.sintomas.removeAt(index); this.cdr.detectChanges(); } }

  evaluarValidacionComentario(index: number): void { /* Conserva tu validación de OTROS */ }

  onCambioManualCarroceria(event: any): void {
    const siluetaSeleccionada = event.target.value; // Traerá "Sedán", "Pickup", "SUV", etc.
    console.log('👉 [SaaS Croquis Edit] Evento change detectado. Valor seleccionado:', siluetaSeleccionada);

    if (siluetaSeleccionada) {
      // 1. Sella el nuevo string de JDE en el control reactivo del formulario principal
      this.editForm.get('tipoSilueta')?.setValue(siluetaSeleccionada);
      this.editForm.get('tipoSilueta')?.markAsDirty();
      this.editForm.get('tipoSilueta')?.markAsTouched();

      // 2. Buscamos el alias en minúsculas en tu mapper para conmutar el SVG gigante
      const nombreArchivo = this.mapperCarroceria[siluetaSeleccionada] || 'sedan';
      this.currentVehicleSvg = `images/croquis-${nombreArchivo}.svg`;
      
      console.log('✅ [SaaS Croquis Edit] Payload reactivo actualizado. Nuevo SVG en RAM:', nombreArchivo);
      this.cdr.detectChanges(); // Fuerza a Angular a repintar los pines sobre el nuevo chasis
    }
  }

  onCroquisClick(event: MouseEvent): void {
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.coordenadasPorcentajeProvisional = { x: ((event.clientX - rect.left) / rect.width) * 100, y: ((event.clientY - rect.top) / rect.height) * 100 };
    this.posicionPantallaMenu = { left: event.clientX + 10, top: event.clientY + 10 };
    this.mostrarMenuFlotante = true;
    this.comentarioTemporal = '';
  }

  confirmarDano(tipo: string): void {
    this.pinesCarroceria.push({ xPercentage: this.coordenadasPorcentajeProvisional.x, yPercentage: this.coordenadasPorcentajeProvisional.y, tipoDano: tipo, descripcion: this.comentarioTemporal.trim().toUpperCase() || 'DAÑO REGISTRADO' });
    this.mostrarMenuFlotante = false;
  }

  cancelarDano(): void { this.mostrarMenuFlotante = false; }
  removerPinCroquis(pin: any): void { this.pinesCarroceria = this.pinesCarroceria.filter(p => p !== pin); this.cdr.detectChanges(); }

  // Modifica tu método onSave() para despachar las fotos y disolver el error 400:
  onSave(): void {
    console.log('📡 ========================================================================');
    console.log('📶 [JDE AUDITORÍA FRONT] 1. Iniciando proceso de empaquetado onSave()...');

    const modalidad = this.editForm.get('modalidadCosto')?.value;
    const monto = this.editForm.get('costoMonto')?.value;

    if (modalidad === 'ESPECIFICO' && (monto === null || monto === undefined || monto <= 0)) {
      this.editForm.get('costoMonto')?.setErrors({ 'invalidCosto': true });
      this.editForm.get('costoMonto')?.markAllAsTouched();
      
      this.toastService.showDanger(
        'Monto Inválido', 
        'Para la modalidad de Costo Específico, el monto debe ser obligatoriamente un valor mayor a \$0.00.'
      );
      this.cdr.detectChanges();
      return; // frena la edición inválida
    }

    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      console.error('❌ [JDE AUDITORÍA FRONT] Formulario inválido. Abortando envío.');
      return;
    }

    const rawForm = this.editForm.getRawValue();

    let codigoModalidad = 0; 
    if (rawForm.modalidadCosto === 'FIJO') codigoModalidad = 1;
    if (rawForm.modalidadCosto === 'VARIABLE') codigoModalidad = 2;
    if (rawForm.modalidadCosto === 'ESPECIFICO') codigoModalidad = 3;    
    
    // 🔍 TELEMETRÍA CONTROL: Verificamos si Angular capturó el croquis en la RAM del formulario
    console.log('📦 [JDE AUDITORÍA FRONT] 2. Valor extraído de editForm.getRawValue().tipoSilueta:', rawForm.tipoSilueta);

    // Filtramos la matriz de fotos originales quitando las eliminadas (Intacto)
    const fotosFinales = this.data.fotos || [];

    const ordenActualizada: any = {
      id: rawForm.id,
      folio: this.data.folio,
      fecha_entrada: this.data.fecha_entrada,
      kilometraje: rawForm.kilometraje,
      nivelCombustible: rawForm.nivelCombustible,
      observaciones_generales: rawForm.observaciones_generales?.toUpperCase(),
      
      // =========================================================================
      // 🚀 INYECCIÓN CRÍTICA DE PERSISTENCIA (SANA EL ERROR DE GUARDADO DE SILUETA)
      // SOLUCIÓN: Incrustamos la variable en el cable de red hacia Spring Boot,
      // permitiendo que Jackson y tu RecepcionesService.java asienten el string 'Pickup'
      // o 'SUV' de forma atómica en la columna 'tipo_silueta' de MySQL.
      // =========================================================================
      tipoSilueta: rawForm.tipoSilueta, 

      // 🌟 VALORES PROCESADOS PARA ACTUALIZAR LA DB
      modalidadCosto: codigoModalidad,
      costoMonto: codigoModalidad === 3 ? parseFloat(rawForm.costoMonto) : 0.00,      
      
      idAsesor: { an8: this.data.idAsesor?.an8 },
      customer: { an8: this.data.customer?.an8 },
      unidad: { id: this.data.unidad?.id },
      detalles: rawForm.detalles,
      sintomas: rawForm.sintomas,
      detallesCarroceria: this.pinesCarroceria,
      fotos: fotosFinales,
      fotosParaBorrarEnDisco: this.fotosEliminadas, 
      firma: this.data.firma || null
    };

    console.log('🎯 [JDE AUDITORÍA FRONT] 3. Objeto FINAL consolidado despachado por red:', ordenActualizada);
    console.log('========================================================================\n');
    
    // Envío multiparte explícito (Intacto)
    this.recepcionesService.updateRecepciones(ordenActualizada, this.archivosSeleccionados).subscribe({
      next: (res: any) => {
        this.archivosSeleccionados = [];
        this.router.navigate(['/recepciones'], {
          state: { mostrarAlertaExito: true, mensajeToast: `La orden vehicular ha sido actualizada con éxito junto con sus evidencias.` }
        });
      },
      error: (err: any) => {
        console.error('Error al actualizar orden en el backend:', err);
        this.toastService.showDanger('Error de Guardado', 'El servidor rechazó la actualización transaccional multiparte.');
      }
    });
  }

  onCancelar(): void { this.location.back(); }
}